import {
  AllStagesIntelligemsAppScopeList,
  IntelligemsAppScopeList,
} from "@intelligems/ig-types";

export const getIntelligemsAppScopes = (stage: string) => {
  if (stage === "prod") {
    return IntelligemsAppScopeList;
  }
  return AllStagesIntelligemsAppScopeList;
};
